import { render, staticRenderFns } from "./write-article.vue?vue&type=template&id=33f46966&scoped=true&"
import script from "./write-article.vue?vue&type=script&lang=js&"
export * from "./write-article.vue?vue&type=script&lang=js&"
import style0 from "./write-article.vue?vue&type=style&index=0&id=33f46966&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f46966",
  null
  
)

export default component.exports